import React, { useEffect, useState } from "react";
import "./Commodity.css";

import AOS from "aos";
import "aos/dist/aos.css";

const Commodity = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <>
      <div>
        <div class="wrapper" id="cover">
          <img
            src={require("../../Assets/images/cover-commodity.jpg")}
            class="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>
            {rtl
              ? `مكتب السلع`
              : fr
              ? `Bureau des Matières Premières`
              : `Commodity Desk`}
          </h1>
        </div>
      </div>
      <div class="bg">
        <section class="about-section padding-tb shape-1 bg ">
          <div class="container">
            <div
              class="col-lg-12 col-12 commodity"
              style={{
                background: "#fff",
                padding: "10px 20px",
                borderRadius: "10px",
              }}
            >
              <div class="header-title text-start m-0">
                <h2 class="my-4">
                  {rtl
                    ? `مكتب السلع`
                    : fr
                    ? `Bureau des Matières Premières`
                    : `Commodity Desk`}
                </h2>
              </div>

              <p>
                {rtl
                  ? `من أجل تلبية احتياجات عملائنا الحكوميين والتجاريين والأفراد بشكل أفضل، سيقدم بنك الاستثمار الإسلامي خدمات مكتب التداول للمعادن الثمينة والأحجار الكريمة والموارد الطبيعية الأخرى وكذلك العملات الأجنبية. وسنعمل مباشرة مع البنوك المركزية لتسييل الموارد الطبيعية لدعم برامج التنمية الاقتصادية والاستثمار المباشر في البلدان الشريكة في "بوابة أفريقيا".
سنقوم بتسهيل معاملات الشراء / البيع ، وصياغة استراتيجيات استثمار بديلة ، ومعالجة متطلبات السيولة لعملائنا. سنقوم بالحصول على المنتج مباشرة من المنتجين ، وتأمين و فاليتكس ، وتنمية علاقات المستثمرين في جميع أنحاء العالم.
`
                  : fr
                  ? `Afin de mieux répondre aux besoins de nos clients gouvernementaux, commerciaux et individuels, la Banque islamique d'investissement offrira des
                  services de négoce pour les métaux précieux, les pierres précieuses et autres ressources naturelles ainsi que pour les devises étrangères. Nous
                  travaillerons directement avec les banques centrales pour monétiser les ressources naturelles afin de soutenir les programmes de développement
                  économique et les investissements directs dans les pays partenaires de la "Porte d'entrée vers l'Afrique". Nous faciliterons les transactions
                  d'achat/vente, formulerons des stratégies d'investissement alternatives et répondrons aux demandes de liquidités de nos clients. Nous nous
                  approvisionnerons directement auprès des producteurs, sécuriserons et valoriserons les produits et cultiverons les relations avec les investisseurs
                  dans le monde entier.`
                  : `In order to better meet the needs of our
                                government, commercial and individual clients,
                                The Islamic investment Bank will offer trading
                                desk services for precious metals, gemstones,
                                and other natural resources as well as foreign
                                currencies. We will work directly with Central
                                Banks to monetize natural resources to support
                                economic development programs and direct
                                investment into “Gateway to Africa” partner
                                countries. We will facilitate buy/sell
                                transactions, formulate alternative investment
                                strategies, and address the liquidity demands
                                for our customers. We will source product
                                directly from producers, secure and valitext,
                                and cultivate investor relationships around the
                                world.`}
              </p>
              <p>
                {rtl
                  ? `هدفنا هو توفير وصول آمن ومريح وسريع إلى الموارد الطبيعية لعملائنا المستثمرين والمستخدمين النهائيين. عندما تكون السيولة مرغوبة ، سيتم بيع المنتج أو تداوله أو استخدامه كضمان للقروض. إذا كان الحفاظ على الثروة هو هدف العميل ، فإن مكاتب التداول لدينا ستقوم بتوريد المنتجات ونقلها ونقلها وتخزينها وتخزينها.
`
                  : fr
                  ? `Notre objectif est de fournir un accès sûr, pratique et rapide aux ressources naturelles pour nos clients investisseurs et utilisateurs finaux. Lorsque la
                  liquidité est souhaitée, le produit sera vendu ou échangé, ou utilisé comme garantie pour des prêts. Si la préservation du patrimoine est l'objectif d'un
                  client, nos bureaux de négociation se chargeront de l'approvisionnement, du transport, de la valorisation et du stockage des produits.`
                  : `Our objective is to provide safe, convenient,
                                and quick access to natural resources for our
                                investor and end-user clients. When liquidity is
                                desired, product will be sold or traded, or used
                                as collateral for loans. If preservation of
                                wealth is a client’s objective, our trading
                                desks will source, transport, valitext, and
                                store products.`}
              </p>
            </div>
          </div>
        </section>

        <section class="feature-section bg-ash padding-tb">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-3 col-sm-6 col-12" data-aos="fade-up">
                <div class="commodity-text-center">
                  <figure class="commodity-overlay commodity-overlay-hover">
                    <img
                      src={require("../../Assets/images/gold-platinum.png")}
                      alt=""
                      class="commodity-menu"
                      draggable="false"
                    />

                    <div class="title-date" style={{ minHeight: "85px" }}>
                      <div class="title">
                        {rtl
                          ? `المعادن الثمينة (الصادرات)`
                          : fr
                          ? `Les Métaux Précieux (Exportations)`
                          : `Precious metals (Exports)`}
                      </div>
                      <div class="text">
                        {rtl
                          ? `الذهب البلاتيني`
                          : fr
                          ? `Platine, Or`
                          : `Gold Platinum`}
                      </div>
                    </div>
                    <figcaption class="commodity-overlay-panel commodity-overlay-background commodity-overlay-slide-bottom">
                      <div class="gb-button">
                        <a href="#precious-metals" draggable="false">
                          <img
                            src={require("../../Assets/image.png")}
                            alt=""
                            class="voir"
                            draggable="false"
                          />
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div
                class="col-lg-3 col-sm-6 col-12"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div class="commodity-text-center">
                  <figure class="commodity-overlay commodity-overlay-hover">
                    <img
                      src={require("../../Assets/images/stone.png")}
                      alt=""
                      draggable="false"
                      class="commodity-menu"
                    />

                    <div class="title-date" style={{ minHeight: "85px" }}>
                      <div class="title">
                        {rtl
                          ? `الأحجار الكريمة (الصادرات)`
                          : fr
                          ? `Pierres Précieuses (Exportations)`
                          : `Precious stones (Exports)`}
                      </div>
                      <div class="text">
                        {rtl
                          ? `الماس الياقوت`
                          : fr
                          ? `Diamant, Saphir`
                          : `Diamonds Rubies`}
                      </div>
                    </div>
                    <figcaption class="commodity-overlay-panel commodity-overlay-background commodity-overlay-slide-bottom">
                      <div class="gb-button">
                        <a href="#Precious-stones" draggable="false">
                          <img
                            src={require("../../Assets/image.png")}
                            alt=""
                            class="voir"
                            draggable="false"
                          />
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div
                class="col-lg-3 col-sm-6 col-12"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="commodity-text-center">
                  <figure class="commodity-overlay commodity-overlay-hover">
                    <img
                      src={require("../../Assets/images/energy.png")}
                      alt=""
                      class="commodity-menu"
                      draggable="false"
                    />

                    <div class="title-date" style={{ minHeight: "85px" }}>
                      <div class="title">
                        {"    "}
                        {rtl
                          ? `الطاقة (الصادرات)`
                          : fr
                          ? `Énergie (Exportations)`
                          : `Energy (Exports)`}
                        {"    "}
                      </div>
                      <div class="text">
                        {rtl
                          ? `البترول الغاز الطبيعي الوقود الفحم`
                          : fr
                          ? `Pétrole, Gaz naturel, Charbon`
                          : `Petroleum Natural Gas Fuels Coal`}
                      </div>
                    </div>
                    <figcaption class="commodity-overlay-panel commodity-overlay-background commodity-overlay-slide-bottom">
                      <div class="gb-button">
                        <a href="#Energy" draggable="false">
                          <img
                            src={require("../../Assets/image.png")}
                            alt=""
                            class="voir"
                            draggable="false"
                          />
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
              <div
                class="col-lg-3 col-sm-6 col-12"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div class="commodity-text-center">
                  <figure class="commodity-overlay commodity-overlay-hover">
                    <img
                      src={require("../../Assets/images/Agriculture.png")}
                      alt=""
                      draggable="false"
                      class="commodity-menu"
                    />

                    <div class="title-date" style={{ minHeight: "85px" }}>
                      <div class="title">
                        {rtl ? `زراعي` : fr ? `Agriculture` : `Agricultural`}{" "}
                        <br />
                        {rtl
                          ? `(الصادرات + الواردات)`
                          : fr
                          ? `(Exportations + Importations)`
                          : `(Exports + Imports)`}
                      </div>
                      <div class="text" id="Agricultural">
                        {rtl
                          ? `الشاي الكاكاو القطن الحمضيات القمح الأرز فول الصويا منتجات اللحوم المجمدة`
                          : fr
                          ? `Thé, cacao, Coton, Agrumes, Blé, Riz, Soja, Produits carnés congelés`
                          : `Tea Cocoa Cotton Citrus Wheat
                                                Rice Soybeans Frozen Meat
                                                Products`}
                      </div>
                    </div>
                    <figcaption class="commodity-overlay-panel commodity-overlay-background commodity-overlay-slide-bottom">
                      <div class="gb-button">
                        <a href="#Agric" draggable="false">
                          <img
                            src={require("../../Assets/image.png")}
                            alt=""
                            class="voir"
                            draggable="false"
                          />
                        </a>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="faith-section padding-tb shape-3 bg">
          <div class="container" data-aos="fade-up">
            <div class="row">
              <div class="col-12">
                {/* <div
                                class="header-title"
                                style={{
                                    textAlign: "center",
                                    marginBottom: "20px",
                                }}
                            >
                                <h2 class="my-4">Precious metals</h2>
                            </div> */}
              </div>
              <div class="col-12">
                <div class="faith-content">
                  <div class="tab-content" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="shahadah"
                      role="tabpanel"
                      aria-labelledby="sahadah-tab"
                    >
                      <div class="lab-item faith-item tri-shape-1 pattern-2">
                        <div class="lab-inner d-flex align-items-center">
                          <div class="lab-thumb">
                            <img
                              src={require("../../Assets/images/gold-platinum.png")}
                              alt="faith-image"
                            />
                          </div>
                          <div class="lab-content">
                            <h4 class="my-4" id="precious-metals">
                              {" "}
                              {rtl
                                ? `المعادن الثمينة`
                                : fr
                                ? `Métaux précieux`
                                : `Precious metals`}
                            </h4>
                            <p>
                              {rtl
                                ? `ينصب تركيزنا في المقام الأول على الذهب والبلاتين في هذا الوقت. منذ عام 4000 قبل الميلاد ، تم استخدام الذهب لتصميم الأشياء الزخرفية. تبعت المجوهرات بعد ألف عام. وبحلول عام 1500 قبل الميلاد ، أصبحت وسيلة للتبادل للتجارة الدولية. وقد استخدمت الحكومات احتياطيات الذهب لدعم قيمة العملة الورقية على الرغم من أن هذا الاستخدام قد تضاءل في الآونة الأخيرة.
  بالإضافة إلى ذلك ، كان الذهب مادة قيمة للصناعة مع مجموعة واسعة من التطبيقات ، من طلاء مرآة التلسكوب إلى التوصيلات الكهربائية ، إلى تطبيقات الرعاية الصحية. وبطبيعة الحال، كان ينظر إلى الذهب دائما على أنه أداة لتخزين الثروة خاصة في شكل عملات معدنية وسبائك.`
                                : fr
                                ? `Pour l'instant, nous nous concentrons principalement sur l'or et le platine. Dès 4000 avant J.-C., l'or
                                était utilisé pour fabriquer des objets décoratifs ; les bijoux ont suivi un millier d'années plus tard ; et
                                vers 1500 avant J.-C., il est devenu le moyen d'échange pour le commerce international. Les réserves
                                d'or ont été utilisées par les gouvernements pour garantir la valeur de la monnaie papier, bien que
                                cette utilisation ait diminué ces derniers temps. En outre, l'or a été un matériau précieux pour
                                l'industrie, avec un large éventail d'applications, du revêtement des miroirs de télescopes aux
                                connexions électriques, en passant par les applications médicales. Et, bien sûr, l'or a toujours été
                                considéré comme un instrument de stockage de la richesse, notamment sous la forme de pièces et de
                                lingots.`
                                : ` Our focus is
                                                            primarily on gold
                                                            and platinum at this
                                                            time. As far back as
                                                            4000 BC, gold was
                                                            used to fashion
                                                            decorative objects;
                                                            jewelry followed a
                                                            thousand years
                                                            later; and by 1500
                                                            BC, it became the
                                                            medium of exchange
                                                            for international
                                                            trade. Gold reserves
                                                            have been used by
                                                            governments to back
                                                            the value of paper
                                                            currency although
                                                            this use has waned
                                                            in recent times. In
                                                            addition, gold has
                                                            been a valuable
                                                            material for
                                                            industry with a wide
                                                            array of
                                                            applications, from
                                                            telescope mirror
                                                            coatings to
                                                            electrical
                                                            connections, to
                                                            healthcare
                                                            applications. And,
                                                            of course, gold has
                                                            always been viewed
                                                            as an instrument for
                                                            storing wealth
                                                            especially in the
                                                            form of coins and
                                                            bullion bars.`}
                            </p>
                            <p>
                              {rtl
                                ? `يستخدم البلاتين في المحولات الحفازة ومعدات المختبرات والاتصالات الكهربائية والأقطاب الكهربائية وموازين الحرارة المقاومة للبلاتين ومعدات طب الأسنان والمجوهرات. كما أنها تستخدم للعملات المعدنية المتخصصة`
                                : fr
                                ? `Le platine est utilisé dans les convertisseurs catalytiques, les équipements de laboratoire, les contacts
                                et électrodes électriques, les thermomètres à résistance en platine, les équipements dentaires et les
                                bijoux. Il est également utilisé pour les pièces de monnaie spéciales.`
                                : `Platinum is used in
                                                            catalytic
                                                            converters,
                                                            laboratory
                                                            equipment,
                                                            electrical contacts
                                                            and electrodes,
                                                            platinum resistance
                                                            thermometers,
                                                            dentistry equipment,
                                                            and jewelry. It is
                                                            also used for
                                                            specialty coins.`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" data-aos="fade-up" data-aos-delay="100">
            <div class="row">
              <div class="col-12">
                {/* <div
                                class="header-title"
                                style={{
                                    textAlign: "center",
                                    marginBottom: "20px",
                                }}
                            >
                                <h2 class="my-4">Precious Stones</h2>
                            </div> */}
              </div>
              <div class="col-12">
                <div class="faith-content">
                  <div class="tab-content" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="shahadah"
                      role="tabpanel"
                      aria-labelledby="sahadah-tab"
                    >
                      <div class="lab-item faith-item tri-shape-1 pattern-2">
                        <div class="lab-inner d-flex align-items-center">
                          <div class="lab-thumb">
                            <img
                              src={require("../../Assets/images/stone.png")}
                              alt="faith-image"
                            />
                          </div>
                          <div class="lab-content">
                            <h4 class="my-4" id="Precious-stones">
                              {" "}
                              {rtl
                                ? `الاحجار الكريمه`
                                : fr
                                ? `Pierres précieuses`
                                : `Precious Stones`}
                            </h4>
                            <p>
                              {rtl
                                ? `وفيما يتعلق بالأحجار الكريمة، سيقوم بنك الاستثمار الإسلامي في المقام الأول بتجارة الماس والياقوت. في حين أن الماس معروف عموما باستخدامه في المجوهرات ، فإن معظم الماس يستخدم صناعيا لقطع وطحن وتلميع وحفر مواد أخرى.
يستخدم الياقوت على نطاق واسع في جميع أشكال المجوهرات وله جاذبية قوية لقواه الصوفية المتصورة بما في ذلك القدرة على تركيز الطاقة ، والحماية من الأفكار السلبية ، وتعزيز التفكير الواضح ؛ ويعتقد أيضا أن الياقوت يوفر فوائد صحية قوية من خلال مكافحة العدوى وتعزيز الخصوبة ومنع المجاعة.`
                                : fr
                                ? `En ce qui concerne les pierres précieuses, La Mecque et la Médine Banque négociera principalement
                                des diamants et des rubis. Si les diamants sont généralement connus pour leur utilisation en bijouterie,
                                la plupart des diamants sont utilisés industriellement pour couper, meuler, polir et percer d'autres
                                matériaux. Les rubis sont largement utilisés dans toutes les formes de bijoux et sont très appréciés
                                pour leurs pouvoirs mystiques, notamment leur capacité à concentrer l'énergie, à protéger des
                                pensées négatives et à favoriser la clarté d'esprit. Les rubis sont également considérés comme très
                                bénéfiques pour la santé car ils combattent les infections, favorisent la fertilité et préviennent la
                                famine.`
                                : `Regarding precious
 
                                                                                                                            stones, The islamic
                                                            investment bank
                                                            primarily will trade
                                                            in diamonds and
                                                            rubies. While
                                                            diamonds are
                                                            commonly known for
                                                            their use in
                                                            jewelry, most
                                                            diamonds are used
                                                            industrially to cut,
                                                            grind, polish and
                                                            drill other
                                                            materials. Rubies
                                                            are used extensively
                                                            in all forms of
                                                            jewelry and have a
                                                            strong appeal for
                                                            their perceived
                                                            mystical powers
                                                            including the
                                                            ability to focus
                                                            energy, shield from
                                                            negative thoughts,
                                                            and to promote clear
                                                            thinking; rubies
                                                            also are believed to
                                                            offer strong health
                                                            benefits by fighting
                                                            infection, promoting
                                                            fertility and
                                                            preventing
                                                            starvation.`}
                            </p>
                            <p>
                              {rtl
                                ? `صناعيا ، يتم استخدامها في تكنولوجيا الليزر لأن قدرتها على تركيز الضوء تؤدي إلى كثافة أعلى من معظم الأحجار الأخرى.`
                                : fr
                                ? `Dans l'industrie, ils sont utilisés dans la technologie laser, car leur capacité à concentrer la lumière
                                permet d'obtenir une intensité plus élevée que la plupart des autres pierres.`
                                : `Industrially, they
                                                            are used in laser
                                                            technology as their
                                                            ability to focus
                                                            light leads to a
                                                            higher intensity
                                                            than most other
                                                            stones.`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" data-aos="fade-up" data-aos-delay="200">
            <div class="row">
              <div class="col-12">
                {/* <div
                                class="header-title"
                                style={{
                                    textAlign: "center",
                                    marginBottom: "20px",
                                }}
                            >
                                <h2 class="my-4">Energy</h2>
                            </div> */}
              </div>
              <div class="col-12">
                <div class="faith-content">
                  <div class="tab-content" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="shahadah"
                      role="tabpanel"
                      aria-labelledby="sahadah-tab"
                    >
                      <div class="lab-item faith-item tri-shape-1 pattern-2">
                        <div class="lab-inner d-flex align-items-center">
                          <div class="lab-thumb">
                            <img
                              src={require("../../Assets/images/energy.png")}
                              alt="faith-image"
                            />
                          </div>
                          <div class="lab-content">
                            <h4 class="my-4" id="Energy">
                              {rtl ? `طاقة` : fr ? `Énergie` : `Energy`}
                            </h4>
                            <p>
                              {rtl
                                ? `وسيتولى المكتب التجاري للطاقة إدارة مخزونات النفط والغاز الطبيعي ونواتج التقطير والفحم. ومن المتوقع أن يكون جزء كبير من التداول داخل القارة بسبب الاحتياجات المحلية على الرغم من أنه سيكون هناك أسواق دولية نشطة أيضا.`
                                : fr
                                ? `Le bureau de négociation pour l'énergie gérera les stocks de pétrole, de gaz naturel, de distillats
                                de carburant et de charbon. Il est prévu qu'une grande partie du commerce se fasse à l'intérieur
                                du continent en raison des besoins locaux, mais il y aura également des marchés internationaux
                                actifs.`
                                : `The trading desk for
                                                            energy will manage
                                                            inventories of
                                                            Petroleum, Natural
                                                            Gas, Fuel
                                                            Distillates and
                                                            Coal. It is
                                                            anticipated that
                                                            much of the trading
                                                            will be
                                                            intra-continental
                                                            due to local needs
                                                            although there will
                                                            active international
                                                            markets, as well.`}
                            </p>
                            <p>
                              {rtl
                                ? `وصف أكثر تفصيلا لقطاع الطاقة الذي سيشارك فيه بنك الاستثمار الإسلامي مفصل في مكان آخر على هذا الموقع وعلى موقعنا الإلكتروني المرتبط به MMH & ABS المجموعة الهندسية www.mmhabs.com`
                                : fr
                                ? `Une description plus détaillée du secteur de l'énergie dans lequel la Banque islamique
                                d'investissement sera impliquée est présentée ailleurs sur ce site et sur notre site associé,
                                MMH&ABS Engineering Group www.mmhabs.com.`
                                : ` A more detailed
                                                            description of the
                                                            Energy sector in
                                                            which The Islamic
                                                            investment Bank will
                                                            be involved is
                                                            detailed elsewhere
                                                            on this website and
                                                            on our associated
                                                            website, MMH&ABS
                                                            Engineering Group
                                                            www.mmhabs.com.`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" data-aos="fade-up" data-aos-delay="300">
            <div class="row">
              <div class="col-12">
                {/* <div
                                class="header-title"
                                style={{
                                    textAlign: "center",
                                    marginBottom: "20px",
                                }}
                            >
                                <h2 class="my-4">Agricultural</h2>
                            </div> */}
              </div>
              <div class="col-12">
                <div class="faith-content">
                  <div class="tab-content" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="shahadah"
                      role="tabpanel"
                      aria-labelledby="sahadah-tab"
                    >
                      <div class="lab-item faith-item tri-shape-1 pattern-2">
                        <div class="lab-inner d-flex align-items-center">
                          <div class="lab-thumb">
                            <img
                              src={require("../../Assets/images/Agriculture.png")}
                              alt="faith-image"
                            />
                          </div>
                          <div class="lab-content">
                            <h4 class="my-4" id="Agric">
                              {rtl
                                ? `زراعي`
                                : fr
                                ? `Agriculture`
                                : `Agricultural`}
                            </h4>
                            <p>
                              {rtl
                                ? `ويشكل الغذاء، على وجه الخصوص، أولوية رئيسية وتحديا رئيسيا لأفريقيا. وفرصة تصدير السلع الزراعية إلى خارج البلد كبيرة بالنسبة للشاي والكاكاو والقطن والحمضيات (من بين أمور أخرى)؛ هذا جيد للمساعدة في تطوير الاقتصاد ولكن ليس لتحسين الصحة الغذائية للأفارقة. الواردات الزراعية / الغذائية الرئيسية اليوم هي القمح والأرز وفول الصويا ومنتجات اللحوم المجمدة (وغيرها).`
                                : fr
                                ? `L'alimentation, en particulier, est une priorité essentielle - et un défi majeur - pour l'Afrique. Les
                                possibilités d'exportation de produits agricoles hors du pays sont importantes pour le thé, le
                                cacao, le coton et les agrumes (entre autres) ; c'est une bonne chose pour aider à développer
                                l'économie mais pas pour améliorer la santé nutritionnelle des Africains. Les principales
                                importations agricoles/alimentaires sont aujourd'hui le blé, le riz, le soja et les produits carnés
                                congelés (entre autres).`
                                : `Food, in particular,
                                                            is a key priority –
                                                            and major challenge
                                                            -- for Africa. The
                                                            opportunity for
                                                            agricultural goods
                                                            being exported out
                                                            of the country is
                                                            significant for Tea,
                                                            Cocoa, Cotton and
                                                            Citrus (among
                                                            others); this is
                                                            fine for helping
                                                            develop the economy
                                                            but not for
                                                            improving the
                                                            nutritional health
                                                            of the Africans.
                                                            Major
                                                            Agricultural/Food
                                                            imports today are
                                                            Wheat, Rice,
                                                            Soybeans, and Frozen
                                                            Meat Products (and
                                                            others).`}
                            </p>
                            <p>
                              {rtl
                                ? `ستكون الواردات محور تركيز بنك الاستثمار الإسلامي لأن هذه الأطعمة ستفيد بشكل مباشر الصحة الغذائية لجميع الأفارقة وخاصة للأطفال في سن المدرسة.`
                                : fr
                                ? `Les importations seront le point de mire de l'Islamic Investment Bank, car ces aliments seront
                                directement bénéfiques pour la santé nutritionnelle de tous les Africains, en particulier pour les
                                enfants en âge scolaire.`
                                : `Imports will be the
                                                            focus for The
                                                            islamic investment
                                                            bank as these foods
                                                            will directly
                                                            benefit the
                                                            nutritional health
                                                            of all Africans
                                                            especially for the
                                                            school-age children.`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Commodity;
